{
  "manifest_version": 3,
  "default_locale": "en",
  "name": "__MSG_appName__",
  "version": "1.0.24",
  "description": "__MSG_appDesc__",
  "background": {
    "service_worker": "background.js"
  },
  "permissions": [
    "storage",
    "identity",
    "search"
  ],
  "host_permissions": [
    "https://api.unsplash.com/*",
    "https://images.unsplash.com/*",
    "https://api.openweathermap.org/*",
    "https://accounts.google.com/*",
    "https://www.googleapis.com/*",
    "https://identitytoolkit.googleapis.com/*",
    "https://securetoken.googleapis.com/*",
    "https://rehmn-48777-default-rtdb.firebaseio.com/*",
    "https://rehmn-48777.firebaseapp.com/*",
    "https://appleid.apple.com/*",
    "https://api.aladhan.com/*",
    "https://api.alquran.cloud/*",
    "https://rhemn-backend-776229077787.us-central1.run.app/*"
  ],
  "chrome_url_overrides": {
    "newtab": "index.html"
  },
  "action": {
    "default_title": "__MSG_actionTitle__"
  },
  "icons": {
    "16": "assets/icon-16.png",
    "48": "assets/icon-48.png",
    "128": "assets/icon-128.png"
  },
  "key": "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAiS8VaJGBKpN3yw8/M44dR4qHvDLshqRaYvRqvJg8LBfT9fJ7LfpHj6nLlH8H9LqTmKthg9hX3dI8lP+qY7OTMlCN4pBCmF9OGkqfH+8TJtQxh94F6VQCYnq6P3YJN5HqBpKfSgz7qJHWvZYDkf9YuGLN3qQd7lMtZ6qHfQhvtKYJ9qJN9sZqJWVqL3qJHTqF9qJHqL3N9sZqJWVJL3N9sZqJWVqL3qJHTqF9F6VQCYnq6P3YJN5HqBpq6P3YJN5HqBpKfSgz7qJHWvZYDkf9YuGLN3qQd7lMtZ6qHfQhvtKYJ9qJN9sZqJWVqL3qJHTqF9qJHqL3N9sZqJWVJL3N9sZqJWVqL3qJHTqF9F6VQwIDAQAB",
  "externally_connectable": {
    "matches": [
      "https://rehmn-48777.firebaseapp.com/*"
    ]
  },
  "content_security_policy": {
    "extension_pages": "script-src 'self'; object-src 'none'; connect-src 'self' https://*.googleapis.com https://rehmn-48777-default-rtdb.firebaseio.com https://rehmn-48777.firebaseapp.com https://identitytoolkit.googleapis.com https://securetoken.googleapis.com https://api.unsplash.com https://images.unsplash.com https://api.openweathermap.org https://api.quran.com https://api.alquran.cloud https://api.aladhan.com https://appleid.apple.com https://rhemn-backend-776229077787.us-central1.run.app https://o4511119813378048.ingest.us.sentry.io; img-src 'self' https://images.unsplash.com https://lh3.googleusercontent.com data:; font-src 'self' https://fonts.gstatic.com; frame-src 'none'; form-action 'none'"
  }
}
